"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VolumeFormat = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var ButtonGroup_1 = __importDefault(require("@material-ui/core/ButtonGroup"));
var FormControl_1 = __importDefault(require("@material-ui/core/FormControl"));
var FormLabel_1 = __importDefault(require("@material-ui/core/FormLabel"));
var VolumeFormat;
(function (VolumeFormat) {
    VolumeFormat["Volume"] = "VOLUME";
    VolumeFormat["Dimensions"] = "DIMENSIONS";
})(VolumeFormat = exports.VolumeFormat || (exports.VolumeFormat = {}));
var FormVolumeFormat = function (_a) {
    var value = _a.value, onChange = _a.onChange, props = __rest(_a, ["value", "onChange"]);
    return (react_1.default.createElement(FormControl_1.default, __assign({ margin: "normal", fullWidth: true }, props),
        react_1.default.createElement(FormLabel_1.default, null, "Volume Format"),
        react_1.default.createElement(ButtonGroup_1.default, { fullWidth: true, color: "primary" },
            react_1.default.createElement(Button_1.default, { className: clsx_1.default(value === VolumeFormat.Volume && "Ptx-selected"), onClick: function () { return onChange === null || onChange === void 0 ? void 0 : onChange(VolumeFormat.Volume); } }, "Volume"),
            react_1.default.createElement(Button_1.default, { className: clsx_1.default(value === VolumeFormat.Dimensions && "Ptx-selected"), onClick: function () { return onChange === null || onChange === void 0 ? void 0 : onChange(VolumeFormat.Dimensions); } }, "Dimensions"))));
};
exports.default = FormVolumeFormat;
//# sourceMappingURL=FormVolumeFormat.js.map